export const PACKAGE_MANAGEMENT = 'PACKAGE_MANAGEMENT';
